import Adapter from 'transport/adapters/Adapter';
import VODLiteAdapter from 'transport/adapters/vod/vod-lite';

import { vodAdapterSettings } from './config';

export const vodAdapterLite = new Adapter(VODLiteAdapter, vodAdapterSettings);



// WEBPACK FOOTER //
// ./src/shared/utils/adapters/vod-lite.js